import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import vi from "./locales/vi.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      vi: { translation: vi },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "vi"],
    // Strip region codes so `vi-VN` → `vi`, `en-US` → `en`, etc.
    load: "languageOnly",
    nonExplicitSupportedLngs: true,
    detection: {
      // First-visit: try localStorage (empty on first visit) → navigator.language
      // → htmlTag → fall back to `en`.
      order: ["localStorage", "navigator", "htmlTag"],
      lookupLocalStorage: "unik-lang",
      caches: ["localStorage"],
    },
    interpolation: { escapeValue: false },
    returnObjects: true,
    returnEmptyString: true,
  });

// Helper: pick a localized field from a data object
// e.g. pickLocale(article, "title") → article.title_vi if lang=vi else article.title
export const pickLocale = (obj, key) => {
  if (!obj) return undefined;
  const lang = i18n.language && i18n.language.startsWith("vi") ? "vi" : "en";
  if (lang === "vi") {
    const viKey = `${key}_vi`;
    if (obj[viKey] !== undefined && obj[viKey] !== null && obj[viKey] !== "") {
      return obj[viKey];
    }
  }
  return obj[key];
};

export default i18n;
